import PropTypes from "prop-types";
import CategoryHeaderCopy from "../CategoryHeaderCopy";
import CategoryHeaderAccordion from "../CategoryHeaderAccordion";
import { LARGE_VIEWPORT } from "../../../../../../state/modules/layout/constants";

const CategoryHeaderContent = ({
  viewportCategory,
  content,
  toggleDescription,
  isDescriptionOpen
}) =>
  viewportCategory === LARGE_VIEWPORT ? (
    <CategoryHeaderCopy content={content} />
  ) : (
    <CategoryHeaderAccordion
      onClick={toggleDescription}
      isOpen={isDescriptionOpen}
      content={content}
    />
  );

CategoryHeaderContent.propTypes = {
  content: PropTypes.string.isRequired,
  isDescriptionOpen: PropTypes.bool.isRequired,
  toggleDescription: PropTypes.func.isRequired,
  viewportCategory: PropTypes.string.isRequired
};

export default CategoryHeaderContent;
